import { Component, ViewChild, OnInit } from '@angular/core';
import { DialogBoxPrintCumplimiento } from './dialog/dialog-print-box.component';
import { MatTable } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { first } from 'rxjs/operators';
import { EvaluacionService } from 'app/main/services/evaluacion.service';
import { ReglaBaseService } from 'app/main/services/regla-base.service';
import { CumplimientoService } from 'app/main/services/cumplimiento.service';
import { Evaluacion } from 'app/main/models/evaluacion.model';
import { Cumplimiento } from 'app/main/models/cumplimiento.model';
import { Router,ActivatedRoute } from '@angular/router';
import { EstructuraJerarquicaService } from 'app/main/services/estructura-jerarquica.service';
import { UsersService } from 'app/main/services/users.service';
import { NodeSelectorDialogBoxComponent} from 'app/main/apps/estructura-jerarquica/dialog/node-selector-dialog-box.component';
import {TranslateService} from '@ngx-translate/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import { getUsuariosNodo } from 'app/main/models/nodo-estructura-jerarquica.model';
import { PonderacionEvaluacion} from 'app/main/models//ponderacion-evaluacion.model';
import { PonderacionObjetivo} from 'app/main/models//ponderacion-objetivo.model';
import { TokenStorageService } from 'app/main/auth/token-storage.service';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';


@Component({
    selector   : 'cumplimiento',
    templateUrl: './cumplimiento.component.html',
    styleUrls  : ['./cumplimiento.component.scss']
})
export class CumplimientoComponent
{
    action: string;
    LOCAL_DATA: Cumplimiento = new Cumplimiento({});
    estructuraJerarquicas = [];
    evaluaciones = [];
    nodosEstructuraJerarquica = [];
    usuarios = [];
    reglas = [];
    disabled = false;

    displayedColumns: string[] = ['nombre','version','escenario','estructuraJerarquica','creador','dueno','fechaInicio','fechaFin','estado','action'];


    constructor(public dialog: MatDialog,
                public service: EvaluacionService,
                private storage: TokenStorageService,
                public serviceEstructuraJerarquica:EstructuraJerarquicaService,
                private _fuseProgressBarService: FuseProgressBarService,
                public userService: UsersService,
                public reglasService: ReglaBaseService,
                public serviceCumplimiento:CumplimientoService,
                private _snackBar: MatSnackBar,
                public router: Router,
                public translate: TranslateService,
                private route: ActivatedRoute) {}

    ngOnInit() {

      this.serviceEstructuraJerarquica.getAll(0,1000).pipe().subscribe(req => {
        this.estructuraJerarquicas = req.body.map( tipo => {
          console.log(tipo);
          return {
            id: tipo.id,
            nombre: tipo.nombre,
            nodos: tipo.nodos
          };
        });
      });

      this.reglasService.getAll(0,1000).pipe().subscribe(req => {
        this.reglas = req.body.map( regla => {
          //console.log(regla);
          return {
            id: regla.id,
            nombre: regla.nombre
          };
        });
      });

    }


    openDialog(): void {
      var user = this.storage.getUser();
      var obj = {usuario: user};
      const dialogRef = this.dialog.open(NodeSelectorDialogBoxComponent, {
        width: '100%',
        data: obj,
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
        this.LOCAL_DATA.nodoEstructuraJerarquica = result.data.nodo;
        this.LOCAL_DATA.estructuraJerarquica = result.data.estructura;
        this.getEvaluaciones();
        this.usuarios = getUsuariosNodo(result.data.nodo);

      });
    }

    getEvaluaciones(){
      if(this.LOCAL_DATA.nodoEstructuraJerarquica!=null && this.LOCAL_DATA.fechaInicio!=null && this.LOCAL_DATA.fechaFin!=null)
        this.service.getByNodoBetweenDates(this.LOCAL_DATA.nodoEstructuraJerarquica.id,this.LOCAL_DATA.fechaInicio,
        this.LOCAL_DATA.fechaFin).pipe().subscribe(req => {
          this.evaluaciones = req.map( evaluacion => {
            console.log(evaluacion);
            return {
              id: evaluacion.id,
              nombre: evaluacion.nombre,
              version: evaluacion.version,
              estructuraJerarquica: evaluacion.estructuraJerarquica,
              fechaCreado: evaluacion.fechaCreado,
              nodoEstructuraJerarquica: evaluacion.nodoEstructuraJerarquica,
              escenario: evaluacion.escenario,
              owner: evaluacion.owner,
              fechaInicio: evaluacion.fechaInicio,
              fechaFin: evaluacion.fechaFin,
              estado: evaluacion.estado,
              tipo: evaluacion.tipo,
              creador: evaluacion.creador,
              objetivos: evaluacion.objetivos
            };
          });
          this.evaluaciones = [...this.evaluaciones];
        });
    }

    addEvaluacion():void{

      this.LOCAL_DATA.evaluaciones = [...this.LOCAL_DATA.evaluaciones];

    }

    removeEvaluacion(evalu):void{

      var indexEval = 0;
      var counter=0;
      this.LOCAL_DATA.evaluaciones.forEach(element => {
        if(element.id == evalu.id)
          indexEval = counter;
        counter+=1;
      });

      this.LOCAL_DATA.evaluaciones.splice(indexEval, 1);
      this.LOCAL_DATA.evaluaciones = [...this.LOCAL_DATA.evaluaciones];
    }

    addCumplimiento(): void {

      this._fuseProgressBarService.show();
      alert("Generando el reporte de cumplimiento, puede tomar unos minutos.");
      this.disabled = true;
      this.serviceCumplimiento.getCumplimiento(this.LOCAL_DATA).pipe(first()).subscribe(
        req => {
          var cumplimiento = req.body;
          cumplimiento.estructuraJerarquica = this.LOCAL_DATA.estructuraJerarquica;
          cumplimiento.nodoEstructuraJerarquica = this.LOCAL_DATA.nodoEstructuraJerarquica;
          cumplimiento.fechaInicio = this.LOCAL_DATA.fechaInicio;
          cumplimiento.fechaFin = this.LOCAL_DATA.fechaFin;

          const dialogRef = this.dialog.open(DialogBoxPrintCumplimiento, {
            panelClass: 'my-full-screen-dialog',
            width: '95%',
            maxWidth: '95%',
            data: {action:"Print", obj:cumplimiento},
            autoFocus: false,
            disableClose: true
          });
          this._fuseProgressBarService.hide();
          this.disabled = false;

          //this.navegateTo('/evaluacion',evaluacion.body.id);
          //this.LOCAL_DATA = new Consolidacion({});
          //this.openSnackBar("Se esta procesando el  creado la consolidación correctamente.","Cerrar");
        },
        error => {
          console.log(error);
          this.disabled = false;
          this._fuseProgressBarService.hide();
          if(error.error.message.indexOf('because "mandato" is null')!=-1){
            this.openSnackBar("La regla base "+this.LOCAL_DATA.reglaBase.nombre+" no posee ningun mandato.","Cerrar");
          }else{
            this.openSnackBar("No se pudo crear el cumplimiento, ocurrió un error.","Cerrar");
          }
        }
      );
    }

    navegateTo(url, id): void  {
        this.router.navigate([url, id]).then( (e) => {
          if (e) {
            console.log("Navigation is successful!");
          } else {
            console.log("Navigation has failed!");
          }
        });
    }

    openSnackBar(message: string, action: string) {
      this._snackBar.open(message, action, {
        duration: 5000,
      });
    }

    esOwnersGroup(usuario):boolean{

      var esOwner:boolean = false;

      usuario.tipos.forEach(element => {
        if(element.id == 4)
          esOwner = true;
      });

      return esOwner;
    }

}
